/**
 * 순서대로 인터셉터 스텝이 실행된다.
 * 순서 잘 지키길
 *  */
const arr = [
  require('./queryStringFilter'),
  require('./myfinbiz'),
  require('./auth'),
  require('./redirect'),
  require('./popState'),
  require('./meta'),
  require('./uiReset'),
  require('./signupManage'),
]

export default arr
